import React, {useContext, useState } from 'react'
import { UserContext } from '../../context/UserContext';
import PurchaseCategoryManager from './PurchaseCategoryManager';
import PurchaseCustomModal from './PurchaseCustomModal';

const PurchaseModal = ({ active, handlePurchaseModal, user_id, id, setErrorMessage }) => {
    const [token] = useContext(UserContext);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [quantity, setQuantity] = useState("");
    const [price, setPrice] = useState(null);

    // const [selectedPrice, setSelectedPrice] = useState(null);

    const handleProductSelect = (productId) => {
        // You could also fetch product details here if needed
        setSelectedProduct(productId);
        };

    const handleProductPrice = (priceValue) => {
        // You could also fetch product details here if needed
        setPrice(priceValue);
        };

    const purchase = async () => {
        if (!selectedProduct) {
            setErrorMessage("No product selected.");
            return;
          }
        const requestOptions = {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                Authorization: "Bearer " + token,
            },
            body: JSON.stringify({ 
                user_id: user_id,
                shop_id: 236,
                type: "purchase",
                amount: quantity,
                status: "string",
                id: 0,
                timestamp: "2024-04-07T18:07:37.706Z",
                items: [
                  {
                    product_id: selectedProduct,
                    quantity: quantity,
                    unit_price: price,
                    id: 0,
                    transaction_id: 0
                  }
                ]
            }),
        };
        try {
            const response = await fetch('/v1/make-purchase', requestOptions);
            if (!response.ok) throw await response.json();
            window.location.reload();
        } catch (error) {
            setErrorMessage(error.detail || 'An error occurred during registration.');
        }
    };

    // Submit registration
    const handleSubmit = (e) => {
          e.preventDefault();
          purchase();

      };

    const modalContent = (
        <>
        <div className="flex flex-row gap-4 w-full">
        <PurchaseCategoryManager 
            onProductSelect={handleProductSelect} 
            onPriceValue={handleProductPrice}

        />
        </div>
        <form onSubmit={handleSubmit} className="space-y-6 p-4">
            <div className="quantity">
                <label htmlFor="quantity" className="block text-sm font-medium text-gray-700">Quantity</label>
                <input
                    type="text"
                    id="quantity"
                    value={quantity}
                    onChange={(e) => setQuantity(e.target.value)}
                    className="mt-1 px-3 py-2 bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full"
                    required
                />
            </div>
          <div className="flex items-center justify-between">
            
            <button
              type="submit"
              className="w-full inline-flex justify-center
               rounded-md border border-transparent 
               shadow-sm px-4 py-2 bg-blue-600 text-base font-medium
                text-white hover:bg-blue-700 focus:outline-none focus:ring-2 
                focus:ring-offset-2 focus:ring-blue-500 sm:text-sm"
            >
              { 'Purchase'}
            </button>
          </div>
        </form>
        </>
      );



  return (
    <PurchaseCustomModal
      active={active}
      handleModal={handlePurchaseModal}
      title={id ? 'Pursschase' : 'Purchase'}
    >
      <div className="w-3/4 mx-auto">{modalContent}</div>
    </PurchaseCustomModal>
  )
}

export default PurchaseModal;
